import React from 'react';

function Forget() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }

    fetch("/forget", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("נשלח אליך מייל להמשך עידכון סיסמה");
          window.location = "/login";
        } else {
          alert(res.err);
        }
      });
  }

  return (
    <div className="container mt-5" dir="rtl">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h3 className="text-center mb-4">עדכון סיסמה</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">כתובת אימייל</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="example@email.com"
                  required
                />
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  שלח קישור לאיפוס סיסמה
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forget;
